import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

const FieldTextarea = ({ control, name, disabled, label, rows = 5, rules }) => {
  return (
    <Controller
      name={name}
      defaultValue=""
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          fullWidth
          variant="filled"
          multiline
          rows={rows}
          disabled={disabled}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
        />
      )}
    />
  );
};

export default FieldTextarea;
